var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "graph-wrapper"
  }, [_c("div", {
    staticClass: "graph-list"
  }, [_c("a-card", {
    attrs: {
      title: "PHP天下第一",
      hoverable: true,
      bordered: false
    }
  }, [_c("surround-graph", {
    staticClass: "chart-graph"
  })], 1)], 1), _c("div", {
    staticClass: "graph-list"
  }, [_c("a-card", {
    attrs: {
      title: "海贼王人物关系图",
      hoverable: true,
      bordered: false
    }
  }, [_c("tree-graph", {
    staticClass: "chart-graph",
    staticStyle: {
      height: "750px"
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };